export type AiImageGalleryWorkflow = 'standard' | 'recipe_refresh' | 'sales_sheet' | 'wine';

export interface AiImageGalleryScope {
  workflow?: AiImageGalleryWorkflow;
  editMode?: 'inpaint' | 'none';
}

export type AiStudioGalleryView = 'create' | 'recipe' | 'wine' | 'sales' | 'edit' | 'review';

export function galleryScopeForView(view: AiStudioGalleryView): AiImageGalleryScope | null {
  switch (view) {
    case 'create':
      return { workflow: 'standard', editMode: 'none' };
    case 'recipe':
      return { workflow: 'recipe_refresh' };
    case 'wine':
      return { workflow: 'wine' };
    case 'sales':
      return { workflow: 'sales_sheet' };
    case 'edit':
      return { editMode: 'inpaint' };
    default:
      return null;
  }
}

export function matchesAiImageGalleryScope(
  item: { workflow?: string | null; editMode?: string | null },
  scope: AiImageGalleryScope | null,
): boolean {
  if (!scope) return false;
  if (scope.editMode === 'inpaint' && item.editMode !== 'inpaint') return false;
  if (scope.editMode === 'none' && item.editMode === 'inpaint') return false;
  if (scope.workflow && (item.workflow || 'standard') !== scope.workflow) return false;
  return true;
}
